import apiClient from './apiClient';

const API_URL = '/pacto';

// Descargar documento PACTO (honorarios) generado automáticamente para un cliente
export const descargarPactoDocumento = async ({ cuil, numeroHaberes, conPorcentaje }) => {
    try {
        const response = await apiClient.get(`${API_URL}/documento`, {
            params: { cuil, numeroHaberes, conPorcentaje },
            responseType: 'blob',
        });
        return response;
    } catch (error) {
        console.error("❌ Error descargando documento PACTO:", error);
        throw error;
    }
};

// Descargar documento PACTO BADARO (2 diferencias + 30%) generado automáticamente para un cliente
export const descargarPactoBadaroDocumento = async ({ cuil }) => {
    try {
        const response = await apiClient.get(`${API_URL}/documento-badaro`, {
            params: { cuil },
            responseType: 'blob',
        });
        return response;
    } catch (error) {
        console.error("❌ Error descargando documento PACTO BADARO:", error);
        throw error;
    }
};

// Adjuntar al trámite los pactos que el operador generó en el formulario de alta. El .docx ya
// se descargó en ese momento (las dos funciones de arriba); esto es el segundo paso, cuando el
// trámite ya existe: el backend los vuelve a generar, los guarda en los Archivos del trámite y
// completa su pacto de honorarios (haberes, 30% y el check "Pacto OK").
export const adjuntarPactosATramite = async (idTramite, pactos) => {
    try {
        const response = await apiClient.post(`${API_URL}/tramite/${idTramite}`, pactos);
        return response.data;
    } catch (error) {
        console.error("❌ Error adjuntando los pactos al trámite:", error);
        throw error;
    }
};
